import React from "react";
import { CircularProgress } from "material-ui/Progress";

const OverlaySpinner = () => {
  return (
    <div style={styles.root}>
      <CircularProgress size={70} thickness={7} />
    </div>
  );
};

const styles = {
  root: {
    alignItems: "center",
    backgroundColor: "rgba(255, 255, 255, 0.9)",
    display: "flex",
    height: "100%",
    justifyContent: "center",
    left: 0,
    position: "absolute",
    top: 0,
    width: "100%"
  }
};

export default OverlaySpinner;



// WEBPACK FOOTER //
// ./src/Shared/OverlaySpinner.js